export default "__VITE_ASSET__zD4vjIRX__"